<template>
    <a :href="getLink(item)"
       :target="getLinkTarget(item)"
       class="menu-item"
       :class="{ 'menu-item-parent' : item.children || item.showCaret, 'disabled': item.disabled, 'menu-item-parent-rotate': item.showCaret }"
       @mouseover="showChildren(item)"
       @mouseout="hideChildren(item)"
       @click="onMenuItemClick(item)">
        <div class="menu-item-name-container">
            <span class="menu-item-icon" :class="item.icon" v-if="item.icon"></span>
            <span class="item-name">{{ item.label }}</span>
        </div>
        <menu-list v-if="item.children"
                   v-show="renderChildren"
                   :items="item.children"
                   class="sub-menu-list" />
    </a>
</template>

<script>

  export default {

    props: {
      item: {
        required: true
      },
      showCaret: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        renderChildren: false
      };
    },

    methods: {

      onMenuItemClick(item) {

        this.$emit('click', item);

        if (item.route)
          this.$router.push(item.route);
        else if (item.onClick)
          item.onClick();

      },

      showChildren(item) {
        this.renderChildren = true;
      },

      hideChildren(item) {
        this.renderChildren = false;
      },

      getLink(item) {
        if (item.link)
          return item.link;
      },

      getLinkTarget(item) {
        if (item.link && item.openLinkInNewPage)
          return '_blank';
      }

    }

  }

</script>

<style lang="scss" scoped>

  .menu-item {
    position: relative;
    background: white;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    color: #585858;
    font-weight: bold;
    padding: 5px 8px;
    height: 25px;
    line-height: 25px;
    white-space: nowrap;
    border: 1px solid #ddd;
    border-bottom: 0;
    display: block;
    text-decoration: none;

    .menu-item-icon {
      margin-right: 5px;
    }

    .sub-menu-list {
      z-index: 100;
    }

    .menu-item-name-container {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .item-name {
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
    }

  }

  .menu-item:last-child {
    border-bottom: 1px solid #ddd;
  }

  .menu-item.disabled {
    pointer-events: none;
    color: #c3c3c3;
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }

  .menu-item:not(.disabled) {
    cursor: pointer;
  }

  .menu-item:hover:not(.disabled) {
    background-color: #EAEAEA;
  }

  .menu-item-parent::after {
    content: "";
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent #585858;
    position: absolute;
    top: 50%;
    right: 3px;
    margin-top: -5px;
  }

  .menu-item-parent-rotate::after {
    transform: rotate(90deg);
    margin-right: 2px;
    margin-top: -3px;
  }

  .menu-item > .menu-list {
    position: absolute;
    left: 100%;
    top: -5%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Common/MenuList/MenuListItem.vue